<template>
    <div class="col-xs-12 col-sm-12 col-md-12" id="user-create">
        <form>
            <div>
                <div class="row justify-content-center">
                    <div class="col-md-10 col-xl-8 text-left">
                        <h4 class="text-left main-title">Enter User Info</h4>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-5 col-xl-4 text-left">
                        <label for="first_name" class="control-label form-item">First Name<span style="color: #c95959">*</span></label>
                        <input v-model="first_name" id="first_name" type="text" class="form-control form-item" name="first_name" autofocus>
                    </div>
                    <div class="col-md-5 col-xl-4 text-left">
                        <label for="last_name" class="control-label form-item">Last Name<span style="color: #c95959">*</span></label>
                        <input v-model="last_name" id="last_name" type="text" class="form-control form-item" name="last_name">
                    </div>
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-md-5 col-xl-4 text-left">
                        <label for="email" class="control-label form-item">E-mail<span style="color: #c95959">*</span></label>
                        <input v-model="email" id="email" type="email" class="form-control form-item" name="email">
                    </div>
                    <div class="col-md-5 col-xl-4 text-left">
                        <label class="control-label form-item">User Type</label>
                        <span id="user-type-picker">
                            <v-select v-model="user_type_id" :reduce="user_type => user_type.id" label="name" :options="user_types"></v-select>
                        </span>
                    </div>
                </div>

                <div class="row justify-content-center mt-2">
                    <div class="col-md-10 col-xl-8 text-right user-types">
                        <span class="inline-block">User Types and Definitions</span>
                        <a @click="toggleUserTypesAndDefinitions"  class="user-types-link">{{ user_types_and_definitions ? 'hide' : 'show' }}</a>
                    </div>
                </div>

                <div class="form-group row justify-content-center">
                    <div :class="{ 'active': user_types_and_definitions }" class="col-md-10 col-xl-8 user-types-and-definitions-container">
                        <table class="table table-bordered text-left">
                            <thead>
                                <tr>
                                    <th>User Type</th>
                                    <th>Access includes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user_type in user_types">
                                    <td>{{ user_type.name }}</td>
                                    <td>{{ user_type.definition }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Removing the weekly and monthly emails selections -->
                <!-- <div v-if="['owner', 'super_admin'].indexOf(user_types_by_id[user_type_id]) > -1" class="row justify-content-center mt-2 margin-bottom30">
                    <div class="col-lg-8 text-left">
                        <h4 class="text-left main-title">Email Excel Reports</h4>

                        <p-input type="checkbox" v-model="email_excel_report_weekly" class="p-default p-curve single" value="weekly">Weekly</p-input>
                        <p-input type="checkbox" v-model="email_excel_report_monthly" class="p-default p-curve single" value="monthly">Monthly</p-input>
                    </div>
                </div> -->

                <div class="form-group row justify-content-center clients-permissions">
                    <div class="col-md-10 col-xl-8">
                        <h4 class="text-left mt-1 main-title">Choose which clients this user has access to</h4>
                    </div>

                    <div class="col-md-10 col-xl-8 mb-3">
                        <label><p-input type="checkbox" class="p-switch p-slim clients-all" id="check_all_users" @change="selectAllClients" :checked="all_clients_checked">Select all</p-input></label>
                    </div>
                    <div class="col-md-10 col-xl-8">
                        <div class="row">
                            <div v-for="(client, index) in clients" class="col-12 col-sm-6 col-lg-4 text-left">
                                <label class="user-label">
                                    <p-input type="checkbox" v-model="selected_clients" class="p-default p-curve users clients single" name="selected_clients[]" @change="checkAll" :checked="all_clients_checked" :value="client.id">{{ client.name }}</p-input>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center mt-5">
                    <div class="col-md-12 text-center">
                        <button @click="saveUser" id="save_user" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>Saving...'
                                :disabled="!validateAddNewUser"
                                type="submit" class="btn btn-secondary"
                                style="pointer-events:initial !important;"
                                :title="validateAddNewUser ? '' : 'You need to complete the data setting to be able to create a user'">Create User</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        mounted() {
            const vueInstance = this;

            $('#create_user_form').on('submit', function() {
                if(vueInstance.submitted == true) return;
                vueInstance.submitted = true;
                $(this).ajaxSubmit({
                    method:'POST',
                    url:window.app_url + '/api/users',
                    data: {
                        user_type_id:               vueInstance.user_type_id,
                        email_excel_report_weekly:  vueInstance.email_excel_report_weekly,
                        email_excel_report_monthly: vueInstance.email_excel_report_monthly
                    },
                    success(response) {
                        vueInstance.notification(vueInstance.messages.USER_CREATED);
                        vueInstance.$router.push({path: '/users'});
                    },
                    complete() {//both success or error
                        vueInstance.submitted = false;
                    }
                    //error case is globally managed, in bootstrap.js
                });
            });
        },

        data() {
            return {
                all_clients_checked: false,
                clients: [],
                user_types: [],
                user_types_by_id:{0:'owner'},
                user_type_id: 1,
                first_name:                 '',
                last_name:                  '',
                email:                      '',
                user_types_and_definitions: false,
                email_excel_report_weekly:  false,
                email_excel_report_monthly: false,
                selected_clients:[],
                submitted:false
            }
        },

        methods: {
            selectAllClients(event) {
                this.all_clients_checked = event;
                $('.clients-permissions .single > input').prop('checked', event);
            },

            checkAll(event){
                if($('.clients-permissions .single > input').length == $('.single > input:checked').length){
                    $('.clients-permissions .clients-all > input').prop('checked', true);
                }
                else{
                    $('.clients-permissions .clients-all > input').prop('checked', false);
                }
            },

            fetchServerData() {
                axios.all([
                    axios.get('/api/clients?with_data=user'),
                    axios.get('/api/users/types')
                ])
                .then(axios.spread((clients, userTypes) => {
                    this.clients    = clients.data;
                    this.user_types = userTypes.data;

                    var userTypesArr = userTypes.data.map(user_type => {
                        return {id: user_type.id, value: user_type.name}
                    })

                    _.each(this.user_types, (user_type) => {
                        this.user_types_by_id[user_type.id] = user_type.short_name;
                    });

                    var filteredUsers = userTypesArr.filter( user => {
                        return user.value.toLowerCase() !== 'owner';
                    })

                    if(!clients.data.length){
                        window.location = this.$store.app_url + '/page-not-found';
                        return;
                    }
                }));
            },

            blur_after_change(event){
                $(event.target).closest('.form-group').find('*').blur();
            },

            toggleUserTypesAndDefinitions() {
                this.user_types_and_definitions = !this.user_types_and_definitions;
            },
            saveUser() {
                if(this.submitted == true) return;
                this.submitted = true;
                $('#save_user').button('loading');

                let formData = new FormData;
                formData.append('first_name', this.first_name);
                formData.append('last_name', this.last_name || '');
                formData.append('email', this.email || '');
                formData.append('user_type_id', this.user_type_id || 1);
                formData.append('selected_clients', this.selected_clients.length ? JSON.stringify(this.selected_clients) : '');
                formData.append('user_types_and_definitions', this.user_types_and_definitions || false);
                formData.append('email_excel_report_weekly', this.email_excel_report_weekly || false);
                formData.append('email_excel_report_monthly', this.email_excel_report_monthly || false);

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/users', formData).then(response => {
                    $('#save_user').button('reset');

                    this.$notify({
                        type: 'success',
                        text: this.messages.USER_CREATED
                    });

                    setTimeout(() => {
                        this.$router.push({path: `/users/edit/${response.data.id}`});
                    }, 3000);
                });
            }
        },

        computed: {
            validateAddNewUser() {
                return !!(this.first_name && this.last_name && this.email && !this.submitted);
            }
        },
        watch:{
            user_type_id(value){
                if(['owner', 'super_admin'].indexOf(this.user_types_by_id[value]) === -1){
                    this.email_excel_report_weekly = false;
                    this.email_excel_report_monthly = false;
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    #user-create{
        .inline-block {
            display: inline-block;
        }

        .user-types {
            font-size: 1.28rem;
        }
        .user-types-link {
            cursor: pointer;
            font-weight: 500;
        }

        th {
            font-weight: 500;
        }
        .main-title {
            padding-left: 0;
            margin-bottom: 2rem;
        }
        .user-types-and-definitions-container {
            display:flex;
            justify-content:right;
            max-height: 0;
            transition: max-height .25s ease-out;
            overflow: hidden;

            &.active {
                max-height: 80rem;
                transition: max-height .25s ease-in;
            }
        }
        table {
            width: auto;
            font-size: 1.2rem;
        }
        div.bootstrap-select{
            button.dropdown-toggle{

            }
            div.dropdown-menu{
                &.open{
                    min-width:35.2rem;
                    width: 100%;
                }
            }
        }
        button:disabled{
            cursor:not-allowed;
            &:hover{
                color:white;
            }
        }
        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
    }
    .pretty{
        line-height:1 !important;
    }
</style>
